require('./brokerPreContractInfoView.scss');

// @vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');

// @commons
const { ContentBox } = require('commonsComponents/contentBox');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');

// @components
const FeatureTogglingRender = require('components/conditionalRender/featureTogglingRender');

// @helpers
const { formatText, FormattedText, getFinalTitle } = require('core/i18n').i18n;

// @ constants
const { BROKER_STOCKS_CONTRACT_URL, MYPROFILE_BROKER_URL } = require('constants/index');
const { FUNDS_RISK_INDICATOR } = require('constants/flagBasedFeatures');

class BrokerPreContractInfoView extends React.Component {
    handleGoToContracts() {
        if (__CONTACT_CENTER__) {
            this.props.history.push({
                pathname: BROKER_STOCKS_CONTRACT_URL,
                state: {
                    keepState: true
                }
            });
        } else {
            this.props.history.push(BROKER_STOCKS_CONTRACT_URL);
        }
    }

    render() {
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: MYPROFILE_BROKER_URL
            },
            {
                text: formatText('breadcrumb-preContractInfoAndConditions'),
                url: ''
            }
        ];

        const contentBoxTitle = formatText('preContractInfo-contentBoxTitle');

        return (
            <section className="broker-pre-contract-info-view">
                <OKCover size="medium" section="broker">
                    <OKHeaderSubPage
                        breadcrumbConfig={mappingBreadcrumb}
                        subtitleLeft={formatText('preContractInfo-headSubtitle')}
                        finalTitle={getFinalTitle('preContractInfo-headTitle')}
                    >
                        <OKButton
                            modifier="primary"
                            onClick={() => this.handleGoToContracts()}
                        >
                            <FormattedText value="preContractInfo-backToHiringButton" />
                        </OKButton>
                    </OKHeaderSubPage>
                </OKCover>

                <div className="broker-pre-contract-info-view__body">
                    <section className="broker-pre-contract-info-content">
                        <ContentBox
                            id="brokerPreContractInfo"
                            title={contentBoxTitle}
                            noHeaderBorder={true}
                            titleSeparator={true}
                            customClassName="broker-pre-contract-info-content-box"
                        >
                            <section className="broker-pre-contract-info-content__summary">
                                <p className="broker-pre-contract-info-content__first-paragraph">
                                    <FormattedText value="preContractInfo-contentParagraphOne" />
                                </p>
                                <p className="broker-pre-contract-info-content__second-paragraph">
                                    <FormattedText value="preContractInfo-contentParagraphTwo" />
                                </p>
                            </section>
                            <section className="broker-pre-contract-info-content__conditions">
                                <FeatureTogglingRender notAllowedProductKey={FUNDS_RISK_INDICATOR}>
                                    <div className="broker-pre-contract-info-content__risk-box">
                                        <div className="broker-pre-contract-info-content__risk-box-risk">
                                            <span className="broker-pre-contract-info-content__risk-box-risk-value">6</span>/6
                                        </div>
                                        <div className="broker-pre-contract-info-content__risk-box-details">
                                            <FormattedText value="preContractInfo-riskBox1" />
                                        </div>
                                    </div>
                                </FeatureTogglingRender>
                                <h3 className="broker-pre-contract-info-content__conditions-title">
                                    <FormattedText value="preContractInfo-conditionsTitle" />
                                </h3>
                                <div className="broker-pre-contract-info-content__section-row">
                                    <div className="broker-pre-contract-info-content__left-column">
                                        <FormattedText value="preContractInfo-conditionsLeftColumnFirstRow" />
                                    </div>
                                    <div className="broker-pre-contract-info-content__right-column broker-pre-contract-info-content__right-column-50">
                                        <p>
                                            <FormattedText value="preContractInfo-conditionsRightColumnFirstRowParagraphOne" />
                                        </p>
                                    </div>
                                </div>
                                <div className="broker-pre-contract-info-content__section-row">
                                    <div className="broker-pre-contract-info-content__left-column">
                                        <FormattedText value="preContractInfo-conditionsLeftColumnSecondRow" />
                                    </div>
                                    <div className="broker-pre-contract-info-content__right-column broker-pre-contract-info-content__right-column-50">
                                        <p className="broker-pre-contract-info-content__titles-first-paragraph">
                                            <FormattedText value="preContractInfo-conditionsRightColumnSecondRowParagraphOne" />
                                        </p>
                                        <p>
                                            <FormattedText value="preContractInfo-conditionsRightColumnSecondRowParagraphTwo" />
                                        </p>
                                    </div>
                                </div>
                                <div className="broker-pre-contract-info-content__section-row">
                                    <div className="broker-pre-contract-info-content__left-column">
                                        <FormattedText value="preContractInfo-conditionsLeftColumnThirdRow" />
                                    </div>
                                    <div className="broker-pre-contract-info-content__right-column">
                                        <p>
                                            <FormattedText value="preContractInfo-conditionsRightColumnThirdRowParagraphOne" />
                                        </p>
                                    </div>
                                </div>
                                <div className="broker-pre-contract-info-content__section-row">
                                    <div className="broker-pre-contract-info-content__left-column">
                                        <FormattedText value="preContractInfo-conditionsLeftColumnFourthRow" />
                                    </div>
                                    <div className="broker-pre-contract-info-content__right-column">
                                        <p className="broker-pre-contract-info-content__operation-first-paragraph">
                                            <FormattedText value="preContractInfo-conditionsRightColumnFourthRowParagraphOne" />
                                        </p>
                                        <p className="broker-pre-contract-info-content__operation-second-paragraph">
                                            <FormattedText value="preContractInfo-conditionsRightColumnFourthRowParagraphTwo" />
                                        </p>
                                        <p className="broker-pre-contract-info-content__operation-third-paragraph">
                                            <FormattedText value="preContractInfo-conditionsRightColumnFourthRowParagraphThree" />
                                        </p>
                                        <p className="broker-pre-contract-info-content__operation-forth-paragraph">
                                            <FormattedText value="preContractInfo-conditionsRightColumnFourthRowParagraphFour" />
                                        </p>
                                        <p className="broker-pre-contract-info-content__operation-fifth-paragraph">
                                            <FormattedText value="preContractInfo-conditionsRightColumnFourthRowParagraphFive" />
                                        </p>
                                    </div>
                                </div>
                                <div className="broker-pre-contract-info-content__section-row">
                                    <div className="broker-pre-contract-info-content__left-column">
                                        <FormattedText value="preContractInfo-conditionsLeftColumnFifthRow" />
                                    </div>
                                    <div className="broker-pre-contract-info-content__right-column">
                                        <p className="broker-pre-contract-info-content__services-first-paragraph">
                                            <FormattedText value="preContractInfo-conditionsRightColumnFifthRowParagraphOne" />
                                        </p>
                                        <p className="broker-pre-contract-info-content__services-second-paragraph">
                                            <FormattedText value="preContractInfo-conditionsRightColumnFifthRowParagraphTwo" />
                                        </p>
                                        <p className="broker-pre-contract-info-content__services-third-paragraph">
                                            <FormattedText value="preContractInfo-conditionsRightColumnFifthRowParagraphThree" />
                                        </p>
                                    </div>
                                </div>
                                <div className="broker-pre-contract-info-content__section-row">
                                    <div className="broker-pre-contract-info-content__left-column">
                                        <FormattedText value="preContractInfo-conditionsLeftColumnSixthRow" />
                                    </div>
                                    <div className="broker-pre-contract-info-content__right-column">
                                        <p>
                                            <FormattedText value="preContractInfo-conditionsRightColumnSixthRowParagraphOne" />
                                        </p>
                                    </div>
                                </div>
                                <div className="broker-pre-contract-info-content__last-section-row">
                                    <div className="broker-pre-contract-info-content__left-column">
                                        <FormattedText value="preContractInfo-conditionsLeftColumnSeventhRow" />
                                    </div>
                                    <div className="broker-pre-contract-info-content__right-column">
                                        <p>
                                            <FormattedText value="preContractInfo-conditionsRightColumnSeventhRowParagraphOne" />
                                        </p>
                                    </div>
                                </div>
                            </section>
                            <section className="broker-pre-contract-info-content__regulations">
                                <h3 className="broker-pre-contract-info-content__regulations-title">
                                    <FormattedText value="preContractInfo-regulationsMainTitle" />
                                </h3>
                                <p className="broker-pre-contract-info-content__regulations-paragraph">
                                    <FormattedText value="preContractInfo-regulationsParagraphOne" />
                                </p>
                                <p className="broker-pre-contract-info-content__regulations-paragraph">
                                    <FormattedText value="preContractInfo-regulationsParagraphTwoNormalTextOne" />
                                    <b><FormattedText value="preContractInfo-regulationsParagraphTwoBoldTextOne" /></b>
                                    <FormattedText value="preContractInfo-regulationsParagraphTwoNormalTextTwo" />
                                </p>
                                <h3 className="broker-pre-contract-info-content__section-title">
                                    <FormattedText value="preContractInfo-regulationsInnerTitle" />
                                </h3>
                                <p className="broker-pre-contract-info-content__regulations-last-paragraph">
                                    <FormattedText value="preContractInfo-regulationsParagraphThree" />
                                </p>
                            </section>
                        </ContentBox>
                    </section>
                </div>
            </section>
        );
    }
}

BrokerPreContractInfoView.propTypes = {
    history: PropTypes.object.isRequired,
}

module.exports = withRouter(BrokerPreContractInfoView);
